<template>
  <div class="col-12 col-md-6 col-lg-4  mb-4 mb-lg-0">
    <div id="libchat_eb4e5e502cdbd1d18d784873d8130e93"></div>
  </div>
</template>

<script>
import { loadScript } from 'vue-plugin-load-script'

export default {
  data () {
    return { }
  },

  mounted () {
    loadScript('https://calstate.libanswers.com/load_chat.php?hash=eb4e5e502cdbd1d18d784873d8130e93')
  }
}
</script>

<style scoped>

</style>
